import { request } from '@/libs/api-request'
import { BEUSABLY_URL, getS3Url } from '@/libs/utils'

export function getHeatMapData (params, force) {
  let url = '/es/get_heatmap_by_event'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}
export function getHeatmapClickData (params, reportView, force) {
  let url = '/ba/apply/heatmap/get_by_event'
  if (reportView === 'target') {
    url = '/ba/targeting/heatmap/get_by_event'
  }

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force).then(data => {
    return data
  }).catch(err => {
    if (err.message.toLowerCase() === 'no stream found') {
      return null
    }
    throw err
  })
}

export function createBaApply (params, force) {
  let url = '/ba/apply/create'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function updateBaApply (params, force) {
  let url = '/ba/apply/update'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function deleteBaApply (params, force) {
  let url = '/ba/apply/delete'

  const config = {
    method: 'post',
    url,
    data: params
  }

  return request(config, force)
}

export function getScrollData (params, reportView, force) {
  let url = '/ba/apply/heatmap/get_scroll'
  if (reportView === 'target') {
    url = '/ba/targeting/heatmap/get_scroll'
  }
  const config = {
    method: 'post',
    url: url,
    data: params
  }

  return request(config, force)
}

export function getStreamPathData (params, reportView, force) {
  let url = '/ba/apply/heatmap/get_path'
  if (reportView === 'target') {
    url = '/ba/targeting/heatmap/get_path'
  }
  const config = {
    method: 'post',
    url: url,
    data: params
  }

  return request(config, force).then(data => {
    return data
  }).catch(err => {
    if (err.message.toLowerCase() === 'no stream found') {
      return null
    }
    throw err
  })
}

export function getSwipePathData (params, reportView, force) {
  let url = '/ba/apply/heatmap/get_swipe'
  if (reportView === 'target') {
    url = '/ba/targeting/heatmap/get_swipe'
  }

  const config = {
    method: 'post',
    url: url,
    data: params
  }

  return request(config, force).then(data => {
    return data
  }).catch(err => {
    if (err.message.toLowerCase() === 'no stream found') {
      return null
    }
    throw err
  })
}

export function getCaptureImageUrl (params, timestamp) {
  const config = {
    method: 'post',
    url: '/coords/get_image_path',
    data: params
  }

  // do not use cache
  return request(config, true).then(data => {
    if (data && data.imagePath) {
      return getS3Url(data.imagePath, timestamp)
    }
    return null
  })
}

export function getAvgFoldData (params, reportView) {
  let url = '/ba/apply/heatmap/get_average_fold'
  if (reportView === 'target') {
    url = '/ba/targeting/heatmap/get_average_fold'
  }

  const config = {
    method: 'post',
    url: url,
    data: params
  }

  return request(config).then(data => {
    const avgFold = data.avgfold

    if (avgFold) {
      return avgFold
    }
    return null
  })
}

export function reportProblem (param, force) {
  const config = {
    method: 'post',
    url: '/apply/report_problem',
    data: param
  }

  return request(config, force)
}

export function requestCapture (param, force) {
  const config = {
    method: 'post',
    url: '/capture' + `${param}`,
    data: {
      'bBaApply': true
    }
  }

  return request(config, force)
}

export function checkCapture (param, force) {
  const config = {
    method: 'get',
    url: '/capture/get_capture_status' + `${param} `
  }

  return request(config, force)
}

export function checkMoveToMyJam (force) {
  let url = `/ba/apply/move_to_my_jam_check`

  const config = {
    method: 'get',
    url
  }

  return request(config, force)
}

export function getHeatmapImage (params) {
  const config = {
    method: 'post',
    url: `${BEUSABLY_URL}/viewer/beusable_capture`,
    data: params
  }

  return request(config)
}

export function getHeatmapPV (params, reportView, force = true) {
  let url = '/ba/apply/heatmap/get_pv'
  if (reportView === 'target') {
    url = '/ba/targeting/heatmap/get_pv'
  }

  const config = {
    method: 'post',
    url: url,
    data: params
  }
  return request(config, force)
}
